<template>
  <div class="image">
    <img
      :src="getItem(content.image)"
      class="image disabled"
      @load="imageLoaded">
    <scroll-image-content
      v-if="content.content"
      :content="content.content"
    />
  </div>
</template>
<script>

import ScrollImageContent from './ScrollImageContent';

export default {
  components: {
    ScrollImageContent,
  },
  props: {
    content: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getItem(img) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`../../assets/img/${img}`);
    },
    imageLoaded() {
      this.$emit('image-loaded');
    },
  },
};
</script>

<style lang="scss" scoped>
  .image {
    height: 100%;
    width: auto;
    position: relative;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
  }

  .disabled {
    pointer-events: none;
  }

  .hidden {
    opacity: 0;
  }

</style>




// WEBPACK FOOTER //
// src/components/scrollimage/ScrollImage.vue